<template>
  <q-col :span="20">
    <!--        <q-page-header />-->
    <router-view />
  </q-col>
</template>

<script>
  export default {
    name: "QMainContainer"
  }
</script>

<style scoped>

</style>